import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import Regions from 'cityads-v3/components/Format/Regions';
import TextCollapser from './TextCollapser';

import classes from './RegionsCollapser.scss';

export default function RegionsCollapser({ ids, ...rest }) {
  const truncateRef = useRef(null);

  // Принудительное обновление коллапсера после перерисовки гео.
  // Иначе там будет старый текст
  const onRegionsUpdate = useCallback(() => {
    truncateRef.current?.onResize();
  }, []);

  return (
    <TextCollapser
      ellipsis = {(
        <span className={classes.ellipsis}>...[{ids.length}+]</span>
      )}
      truncateRef = {truncateRef}
      {...rest}
    >
      <Regions ids={ids} onUpdate={onRegionsUpdate} />
    </TextCollapser>
  );
}

RegionsCollapser.propTypes = {
  ids       : PropTypes.arrayOf(PropTypes.number).isRequired,
  lines     : PropTypes.number,
  expanded  : PropTypes.bool,
  onTruncate: PropTypes.func,
};